import React, { useMemo, useEffect } from 'react'
import { Alert, Tabs } from 'antd'
import { useSelector } from 'react-redux'

import { ResumeAirRequestQuoteAirs } from 'src/types'

import { ApplicationState } from 'src/store'

import { PickFareProps } from '.'
import SearchResultItem from '../SearchResultItem'

type Props = PickFareProps & {
  setPolicyListCheck(list: ResumeAirRequestQuoteAirs[]): void
}

function OneWay({ selectedFares, onPickFare, setPolicyListCheck }: Props) {
  const { air } = useSelector((state: ApplicationState) => ({
    air: state.air
  }))

  const searchKey = useMemo(() => {
    return Object.keys(air.searches)[0]
  }, [air.searches])

  const list = useMemo(
    () =>
      air.searches[searchKey].list[0]
        ? air.searches[searchKey].list[0].request_quote_airs
        : [],
    [air.searches, searchKey]
  )

  useEffect(() => {
    setPolicyListCheck(list)
  }, [list, setPolicyListCheck])

  return (
    <Tabs data-test-id="air-result-panel-card" defaultActiveKey={searchKey}>
      <Tabs.TabPane
        data-test-id={`air-result-panel-${searchKey}-list`}
        tab={searchKey}
        key={searchKey}
      >
        <>
          {air.searches[searchKey]?.error && (
            <Alert
              closable={false}
              message={air.searches[searchKey].error}
              type="error"
            />
          )}
          {!air.searches[searchKey]?.error && (
            <SearchResultItem
              selectedFares={selectedFares}
              onPickFare={onPickFare}
              searchKey={searchKey}
              list={list}
            />
          )}
        </>
      </Tabs.TabPane>
    </Tabs>
  )
}

export default OneWay
